module.exports = __webpack_public_path__ + "static/media/banner_l_07.cfb2de17.jpg";